import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=608b5e34&scoped=true"
import script from "./ReviewDetail.vue?vue&type=script&lang=ts"
export * from "./ReviewDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReviewDetail.vue?vue&type=style&index=0&id=608b5e34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608b5e34",
  null
  
)

export default component.exports